import { ContractingFormType } from "features/contracting/enums/contractingFormType";
import CustomerDataFormSection from "./customerDataForm/CustomerDataFormSection";
import CustomerTypeFormSection from "./customerTypeForm/CustomerTypeFormSection";
import PaymentMethodFormSection from "./paymentMethodForm/PaymentMethodFormSection";
import ContractingStepFormProps from "features/contracting/models/ContractingStepFormProps";
import ProcessFormSection from "./processForm/ProcessFormSection";
import PlaceOfDeliveryFormSection from "./placeOfDeliveryForm/PlaceOfDeliveryFormSection";
import ProductFormSection from "./productForm/ProductFormSection";
import OverviewFormSection from "./overviewForm/OverviewFormSection";

type ContractingForm = (props: ContractingStepFormProps) => JSX.Element;
type ComponentMap = Record<ContractingFormType, ContractingForm>;

export const ContractingFormsMap: ComponentMap = {
  "customerData": CustomerDataFormSection,
  "customerType": CustomerTypeFormSection,
  "paymentMethod": PaymentMethodFormSection,
  "process": ProcessFormSection,
  "placeOfDelivery": PlaceOfDeliveryFormSection,
  "product": ProductFormSection,
  "overview": OverviewFormSection
}